import { defineComponent as i, createElementBlock as c, openBlock as o, createElementVNode as t, createBlock as n, unref as a, toDisplayString as d, createCommentVNode as m, createVNode as b } from "vue";
import { ScalarColorModeToggle as u } from "@scalar/components";
import { ScalarIconX as h, ScalarIconList as S, ScalarIconMagnifyingGlass as g } from "@scalar/icons";
const p = { class: "t-doc__header mobile-header" }, k = { class: "mobile-header-breadcrumbs" }, f = { class: "mobile-header-actions" }, C = /* @__PURE__ */ i({
  __name: "DocumentMobileHeader",
  props: {
    label: {},
    showSideBar: { type: Boolean }
  },
  emits: ["showSearch", "toggleSidebar"],
  setup(r, { emit: s }) {
    const l = s;
    return (y, e) => (o(), c("div", p, [
      t("button", {
        class: "icon-button",
        type: "button",
        onClick: e[0] || (e[0] = () => l("toggleSidebar"))
      }, [
        r.showSideBar ? (o(), n(a(h), { key: 0 })) : (o(), n(a(S), { key: 1 }))
      ]),
      t("span", k, d(r.label), 1),
      t("div", f, [
        t("button", {
          class: "icon-button",
          type: "button",
          onClick: e[1] || (e[1] = () => l("showSearch"))
        }, [
          b(a(g))
        ]),
        r.showSideBar ? m("", !0) : (o(), n(a(u), {
          key: 0,
          class: "mobile-header-darkmode-toggle"
        }))
      ])
    ]));
  }
});
export {
  C as default
};
